import UxButton from '@ux/button';
import '@ux/button/dist/styles.css';

export const Button = UxButton;
